export const fromMagentoCurrency = (magentoCurrency) => {
    const code = magentoCurrency.defaultDisplayCurrencyCode;
    const symbol = magentoCurrency.defaultDisplayCurrencySymbol;
    return { code, symbol };
};
//# sourceMappingURL=fromMagentoCurrency.js.map